import { render, staticRenderFns } from "./PunishmentWhen.vue?vue&type=template&id=4fce8038&scoped=true&"
import script from "./PunishmentWhen.vue?vue&type=script&lang=ts&"
export * from "./PunishmentWhen.vue?vue&type=script&lang=ts&"
import style0 from "./PunishmentWhen.vue?vue&type=style&index=0&id=4fce8038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce8038",
  null
  
)

export default component.exports